var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 16,
    viewBox: "0 0 46 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.80915 15.616C7.41007 15.616 8.92446 14.7506 9.59512 13.4742V15.4429H10.9581V0.125977H9.59512V6.50804C8.92446 5.23163 7.41007 4.36626 5.80915 4.36626C2.34769 4.36626 0.508789 6.87582 0.508789 9.99114C0.508789 13.1065 2.34769 15.616 5.80915 15.616ZM5.85242 14.3612C3.4943 14.3612 1.95828 12.6305 1.95828 9.99114C1.95828 7.35177 3.4943 5.62104 5.85242 5.62104C8.21054 5.62104 9.74656 7.35177 9.74656 9.99114C9.74656 12.6305 8.21054 14.3612 5.85242 14.3612Z",
    fill: "url(#paint0_linear_1_2411)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8914 15.616C22.0932 15.616 24.3864 13.2795 24.3864 9.99114C24.3864 6.70275 22.0932 4.36626 18.8914 4.36626C15.6895 4.36626 13.3963 6.70275 13.3963 9.99114C13.3963 13.2795 15.6895 15.616 18.8914 15.616ZM18.8914 14.3612C16.4683 14.3612 14.8242 12.544 14.8242 9.99114C14.8242 7.43831 16.4683 5.62104 18.8914 5.62104C21.3144 5.62104 22.9586 7.43831 22.9586 9.99114C22.9586 12.544 21.3144 14.3612 18.8914 14.3612Z",
    fill: "url(#paint1_linear_1_2411)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3286 15.616C34.0762 15.616 35.742 14.2531 36.1314 12.068H34.8334C34.4007 13.4959 33.1243 14.3612 31.3286 14.3612C28.7542 14.3612 27.5427 12.3493 27.5427 9.99114C27.5427 7.63302 28.7325 5.62104 31.3286 5.62104C33.1243 5.62104 34.617 6.68112 34.8334 8.10897H36.1747C35.8069 5.70758 33.6435 4.36626 31.3286 4.36626C27.8672 4.36626 26.1148 7.13543 26.1148 9.99114C26.1148 12.8468 27.8672 15.616 31.3286 15.616Z",
    fill: "url(#paint2_linear_1_2411)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0625 15.616C44.4206 15.616 45.9999 14.4045 45.9999 12.5007C45.9999 7.48158 39.4881 10.5104 39.4881 7.35177C39.4881 6.31334 40.4183 5.62104 41.8246 5.62104C42.863 5.62104 44.399 6.09699 44.5721 7.63302H45.935C45.8052 5.66431 44.2259 4.36626 41.9111 4.36626C39.5746 4.36626 38.0602 5.53451 38.0602 7.35177C38.0602 12.0896 44.5721 8.93106 44.5721 12.5007C44.5721 13.4959 43.5769 14.3612 42.0625 14.3612C40.3318 14.3612 39.315 13.5391 39.1636 12.0031H37.8006C37.9737 14.2531 39.5962 15.616 42.0625 15.616Z",
    fill: "url(#paint3_linear_1_2411)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2411",
    x1: 65.2815,
    y1: 15.616,
    x2: 65.2815,
    y2: 0.125977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#843BD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE3E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_2411",
    x1: 65.2815,
    y1: 15.616,
    x2: 65.2815,
    y2: 0.125977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#843BD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE3E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_2411",
    x1: 65.2815,
    y1: 15.616,
    x2: 65.2815,
    y2: 0.125977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#843BD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE3E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_2411",
    x1: 65.2815,
    y1: 15.616,
    x2: 65.2815,
    y2: 0.125977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#843BD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE3E9C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocsLogo);
export default __webpack_public_path__ + "static/media/docsLogo.d456d40f.svg";
export { ForwardRef as ReactComponent };